import api from "./api";

export async function getAllPersons() {
  const response = await api.get("/persons");
  return response.data;
}

export async function getPerson(id) {
  const response = await api.get(`/persons/${id}`);
  return response.data;
}

export async function getWeightEntriesForPerson(id) {
  const response = await api.get(`/persons/${id}/weightentries`);
  return response.data;
}

export async function getMissionsForPerson(id) {
  const response = await api.get(`/persons/${id}/missions`);
  return response.data;
}

export async function createWeightEntry(personId, weightEntry) {
  const response = await api.post(`/persons/${personId}/weightentries`, weightEntry);
  return response.data;
}